module.exports = __webpack_public_path__ + "img/Green.227ae5b0.png";